import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.admin.dpo');
import { Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";

@Component({
    selector: 'wiz-component-admin-dpo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.admin.dpo/view.scss */
:host {
  display: block;
  min-width: 0;
}

.admin-dpo {
  min-width: 0;
  padding: 20px;
  border-radius: 14px;
  border: 1px solid var(--ui-line);
  background: var(--ui-paper);
  box-shadow: none;
  color: var(--ui-ink);
  font-size: 13px;
  line-height: 1.6;
  /* One heading, one filter row, then the participant register. */
  /* Scope statistics and policy stay separate from the filtered result count. */
  /* Long-form answers retain their reading size. */
}
.admin-dpo *, .admin-dpo *::before, .admin-dpo *::after {
  box-sizing: border-box;
}
.admin-dpo ::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}
.admin-dpo h2, .admin-dpo h3, .admin-dpo h4, .admin-dpo p {
  margin: 0;
}
.admin-dpo h2 {
  font-size: 18px;
  font-weight: 650;
  line-height: 1.5;
  letter-spacing: -0.02em;
}
.admin-dpo h3 {
  font-size: 16px;
  font-weight: 650;
}
.admin-dpo h4 {
  font-size: 14px;
  font-weight: 650;
}
.admin-dpo button, .admin-dpo input, .admin-dpo textarea, .admin-dpo select {
  font: inherit;
}
.admin-dpo button, .admin-dpo a, .admin-dpo input, .admin-dpo textarea, .admin-dpo select, .admin-dpo summary {
  outline-offset: 3px;
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 16px);
  scroll-margin-bottom: 120px;
}
.admin-dpo :focus-visible {
  outline: 3px solid var(--ui-accent);
}
.admin-dpo [tabindex="-1"] {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 16px);
  scroll-margin-bottom: 96px;
}
.admin-dpo h2:focus, .admin-dpo h3:focus {
  outline: none;
}
.admin-dpo button {
  cursor: pointer;
}
.admin-dpo button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}
.admin-dpo a {
  color: var(--ui-accent);
  text-underline-offset: 3px;
}
.admin-dpo input, .admin-dpo textarea, .admin-dpo select {
  width: 100%;
  min-width: 0;
  min-height: 36px;
  padding: 7px 10px;
  border: 1px solid var(--ui-control);
  border-radius: var(--ui-control-radius, 9px);
  background: var(--ui-paper);
  color: var(--ui-ink);
  line-height: 20px;
  caret-color: var(--ui-accent);
}
.admin-dpo select {
  appearance: auto;
}
.admin-dpo input:hover, .admin-dpo textarea:hover, .admin-dpo select:hover {
  border-color: var(--ui-text);
}
.admin-dpo input::placeholder, .admin-dpo textarea::placeholder {
  color: var(--ui-muted);
  opacity: 1;
}
.admin-dpo textarea {
  resize: vertical;
  line-height: 1.7;
}
.admin-dpo label {
  display: block;
  font-size: 13px;
  font-weight: 600;
}
.admin-dpo summary {
  cursor: pointer;
}
.admin-dpo .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.admin-dpo .button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: var(--ui-control-radius, 9px);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  line-height: 20px;
  white-space: nowrap;
}
.admin-dpo .button.primary {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
}
.admin-dpo .button.primary:hover:not(:disabled) {
  background: var(--ui-accent-hover);
}
.admin-dpo .button.secondary {
  background: var(--ui-paper);
  border-color: var(--ui-control);
  color: var(--ui-text);
}
.admin-dpo .button.secondary:hover:not(:disabled) {
  background: var(--ui-selected);
  border-color: var(--ui-accent);
}
.admin-dpo .text-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 6px 0;
  border: 0;
  background: none;
  color: var(--ui-accent);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.admin-dpo .text-button:hover:not(:disabled) {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.admin-dpo .icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  width: 36px;
  flex-shrink: 0;
  border: 1px solid var(--ui-control);
  border-radius: var(--ui-control-radius, 9px);
  background: var(--ui-paper);
  color: var(--ui-text);
}
.admin-dpo .icon-button:hover:not(:disabled) {
  background: var(--ui-selected);
}
.admin-dpo :is(.button, .icon-button, .admin-dpo-views button, .result-row) {
  transition: background-color var(--ui-duration, 180ms) var(--ui-ease), border-color var(--ui-duration, 180ms) var(--ui-ease);
}
.admin-dpo .admin-dpo-heading {
  display: flex;
  align-items: center;
  gap: 18px;
  margin: -20px -20px 16px;
  padding: 14px 20px;
  min-width: 0;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
  border-radius: 14px 14px 0 0;
}
.admin-dpo .admin-dpo-heading h2 {
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
}
.admin-dpo .direct-review {
  margin-left: auto;
}
.admin-dpo .admin-dpo-views {
  display: inline-flex;
  gap: 3px;
  max-width: 100%;
  padding: 3px;
  border: 1px solid var(--ui-control);
  border-radius: 9px;
  background: var(--ui-paper);
}
.admin-dpo .admin-dpo-views button {
  min-height: 36px;
  padding: 4px 12px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  white-space: nowrap;
}
.admin-dpo .admin-dpo-views button.active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
}
.admin-dpo .admin-dpo-views button.active:hover:not(:disabled) {
  background: var(--ui-accent-hover);
  color: var(--ui-on-navy);
}
.admin-dpo .admin-dpo-views button:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--ui-accent);
}
.admin-dpo .feedback {
  padding: 8px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
}
.admin-dpo .feedback.error {
  color: var(--ui-danger);
}
.admin-dpo .feedback.success {
  color: var(--ui-success);
}
.admin-dpo .loading-note {
  padding: 20px 0;
  color: var(--ui-muted);
}
.admin-dpo .badge, .admin-dpo .review-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 7px;
  border-radius: 4px;
  background: var(--ui-soft);
  color: var(--ui-text);
  font-size: 12px;
  line-height: 18px;
}
.admin-dpo .badge.preferred {
  background: var(--ui-selected);
  color: var(--ui-accent);
}
.admin-dpo .badge.hold, .admin-dpo .review-badge.source-review {
  background: color-mix(in srgb, var(--ui-warning) 12%, var(--ui-paper));
  color: var(--ui-warning);
}
.admin-dpo .pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 0 0;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .pagination button {
  border: 1px solid var(--ui-control);
  background: var(--ui-paper);
  border-radius: 6px;
  min-height: 36px;
  min-width: 36px;
  color: var(--ui-text);
}
.admin-dpo .participation {
  min-width: 0;
}
.admin-dpo .participation-meta {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-bottom: 8px;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 18px;
  font-variant-numeric: tabular-nums;
}
.admin-dpo .participation-total strong {
  font-weight: 650;
  color: var(--ui-ink);
}
.admin-dpo .participation-note {
  margin-left: auto;
}
.admin-dpo .participation-tools {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.admin-dpo .participation-search {
  display: flex;
  gap: 4px;
  flex: 0 1 320px;
  min-width: 0;
}
.admin-dpo .participation-filter {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 0 1 auto;
  padding: 3px;
  background: var(--ui-soft);
  border-radius: 8px;
}
.admin-dpo .participation-filter button {
  min-height: 32px;
  padding: 6px 9px;
  border: 0;
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 12px;
  white-space: nowrap;
}
.admin-dpo .participation-filter button.active {
  background: var(--ui-navy);
  color: var(--ui-on-navy);
}
.admin-dpo .participation-filter button:hover:not(.active):not(:disabled) {
  background: var(--ui-selected);
}
.admin-dpo .participation-refresh {
  margin-left: auto;
}
.admin-dpo .participation-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 18px;
  font-variant-numeric: tabular-nums;
}
.admin-dpo .participation-table thead {
  background: var(--ui-soft);
  color: var(--ui-muted);
}
.admin-dpo .participation-table th, .admin-dpo .participation-table td {
  padding: 12px;
  border-bottom: 1px solid var(--ui-line);
  text-align: right;
  vertical-align: middle;
}
.admin-dpo .participation-table thead th {
  font-size: 12px;
  font-weight: 500;
}
.admin-dpo .participation-table th:first-child {
  width: 38%;
  text-align: left;
}
.admin-dpo .participation-table th:nth-child(2), .admin-dpo .participation-table th:nth-child(3) {
  width: 14%;
}
.admin-dpo .participation-table th:nth-child(4) {
  width: 24%;
}
.admin-dpo .participation-table th:nth-child(5) {
  width: 10%;
}
.admin-dpo .participation-table tbody tr:hover {
  background: var(--ui-soft);
}
.admin-dpo .participation-table .participation-person {
  font-weight: 400;
  white-space: normal;
  min-width: 0;
}
.admin-dpo .participation-person strong {
  font-size: 14px;
  font-weight: 650;
  color: var(--ui-ink);
  overflow-wrap: anywhere;
}
.admin-dpo .participation-person small {
  display: block;
  font-size: 12px;
  line-height: 18px;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}
.admin-dpo .participant-unavailable {
  display: inline-block;
  margin-left: 8px;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .participation-table .mobile-label {
  display: none;
}
.admin-dpo .participation-reviewed > span:last-child {
  font-weight: 650;
  color: var(--ui-ink);
}
.admin-dpo .participation-progress > div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.admin-dpo .participation-progress > div > span {
  min-width: 54px;
}
.admin-dpo .participation-progress progress {
  appearance: none;
  display: block;
  height: 5px;
  width: 100%;
  max-width: 100px;
  border: 0;
  border-radius: 3px;
  overflow: hidden;
  background: var(--ui-line);
  accent-color: var(--ui-success);
}
.admin-dpo .participation-progress progress::-webkit-progress-bar {
  background: var(--ui-line);
}
.admin-dpo .participation-progress progress::-webkit-progress-value {
  background: var(--ui-success);
}
.admin-dpo .participation-progress progress::-moz-progress-bar {
  background: var(--ui-success);
}
.admin-dpo .participation-hold.has-hold {
  color: var(--ui-warning);
  font-weight: 650;
}
.admin-dpo .participation-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 8px;
  min-height: 36px;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .participation-footer nav {
  display: flex;
  gap: 8px;
}
.admin-dpo .participation-loading, .admin-dpo .participation-empty {
  color: var(--ui-muted);
  padding: 20px 0;
  font-size: 13px;
}
.admin-dpo .participation-error {
  color: var(--ui-danger);
  font-size: 13px;
  padding: 8px 0;
}
.admin-dpo .participation-error > .text-button {
  margin-left: 8px;
}
.admin-dpo .results-workspace {
  min-width: 0;
}
.admin-dpo .results-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 16px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--ui-line);
}
.admin-dpo .results-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 20px;
  margin: 0;
  padding: 0;
  min-height: 36px;
}
.admin-dpo .results-summary > div {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.admin-dpo .results-summary dt {
  color: var(--ui-muted);
  font-size: 12px;
  white-space: nowrap;
}
.admin-dpo .results-summary dd {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  line-height: 22px;
  color: var(--ui-ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.admin-dpo .results-summary dd > span {
  margin-left: 3px;
  color: var(--ui-muted);
  font-size: 12px;
  font-weight: 400;
}
.admin-dpo .results-policy {
  margin-left: auto;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .results-policy > summary {
  min-height: 36px;
  padding: 8px 0;
  line-height: 20px;
  color: var(--ui-text);
}
.admin-dpo .results-policy[open] {
  flex-basis: 100%;
  margin-left: 0;
}
.admin-dpo .results-policy-content {
  padding-bottom: 8px;
  max-width: 90ch;
}
.admin-dpo .results-policy-content p + p {
  margin-top: 6px;
}
.admin-dpo .results-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-bottom: 8px;
}
.admin-dpo .results-tools {
  display: grid;
  grid-template-columns: minmax(144px, 1fr) 125px 156px 36px;
  align-items: center;
  gap: 6px;
  flex: 1 1 500px;
  min-width: 0;
}
.admin-dpo .result-search {
  display: flex;
  gap: 4px;
  min-width: 0;
}
.admin-dpo .result-filter {
  min-width: 0;
}
.admin-dpo .results-list-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .results-list-actions > span {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.admin-dpo .result-create {
  position: relative;
}
.admin-dpo .result-create > summary {
  list-style: none;
}
.admin-dpo .result-create > summary::-webkit-details-marker {
  display: none;
}
.admin-dpo .result-create > summary > :is(i, svg) {
  font-size: 10px;
}
.admin-dpo .result-create[open] > summary > :is(i, svg) {
  transform: rotate(180deg);
}
.admin-dpo .result-create-options {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 5;
  display: grid;
  min-width: 180px;
  max-width: calc(100vw - 48px);
  padding: 4px;
  border: 1px solid var(--ui-control);
  border-radius: 10px;
  background: var(--ui-paper);
  text-align: left;
}
.admin-dpo .result-create-options a {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.admin-dpo .result-create-options a:hover {
  background: var(--ui-selected);
  color: var(--ui-accent);
}
.admin-dpo .result-create-options a[aria-disabled=true] {
  opacity: 0.48;
  pointer-events: none;
}
.admin-dpo .result-export-options {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 8px;
}
.admin-dpo .result-exports {
  text-align: right;
}
.admin-dpo .result-exports > summary {
  list-style: none;
}
.admin-dpo .result-exports > summary::-webkit-details-marker {
  display: none;
}
.admin-dpo .result-exports > summary > svg {
  font-size: 10px;
}
.admin-dpo .result-exports[open] > summary > svg {
  transform: rotate(180deg);
}
.admin-dpo .results-list-actions .button {
  font-size: 12px;
}
.admin-dpo .bundle-progress, .admin-dpo .bundle-download {
  margin: 0 0 8px;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .bundle-download {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  align-items: center;
}
.admin-dpo .bundle-download > a {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.admin-dpo .result-columns, .admin-dpo .result-row {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr) 230px 16px;
  align-items: center;
  gap: 16px;
}
.admin-dpo .result-columns {
  padding: 8px 12px;
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 18px;
  border-bottom: 1px solid var(--ui-line);
}
.admin-dpo .result-row {
  width: 100%;
  padding: 14px 12px;
  background: var(--ui-paper);
  color: var(--ui-ink);
  text-align: left;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
}
.admin-dpo .result-row:hover:not(:disabled) {
  background: var(--ui-selected);
}
.admin-dpo .result-row > .badge {
  justify-self: start;
  max-width: 100%;
  white-space: normal;
}
.admin-dpo .result-row > i {
  color: var(--ui-muted);
  font-size: 11px;
}
.admin-dpo .result-question {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.admin-dpo .result-question strong {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.admin-dpo .result-question > .source-review {
  align-self: flex-start;
  color: var(--ui-warning);
}
.admin-dpo .result-question > span {
  font-size: 12px;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}
.admin-dpo .result-votes {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.admin-dpo .vote-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: var(--ui-muted);
}
.admin-dpo .vote-counts > span {
  white-space: nowrap;
}
.admin-dpo .vote-counts b {
  color: var(--ui-ink);
  font-weight: 650;
  margin-left: 3px;
}
.admin-dpo .preference-share {
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .result-empty {
  padding: 24px 12px;
  color: var(--ui-muted);
  text-align: center;
}
.admin-dpo .result-detail {
  padding: 0;
}
.admin-dpo .result-detail-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.admin-dpo .result-detail-actions [aria-disabled=true] {
  opacity: 0.48;
  pointer-events: none;
}
.admin-dpo .result-detail-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-bottom: 8px;
  color: var(--ui-muted);
  font-size: 13px;
}
.admin-dpo .result-detail > h2 {
  font-size: 21px;
  line-height: 1.65;
  max-width: 75ch;
  margin-top: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.admin-dpo .result-source {
  margin-top: 8px;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}
.admin-dpo .result-majority {
  margin-top: 10px;
  color: var(--ui-text);
  font-size: 14px;
}
.admin-dpo .result-distribution {
  padding: 12px 16px;
  margin-top: 8px;
  gap: 24px;
  font-size: 14px;
  border-radius: 9px;
  background: var(--ui-soft);
}
.admin-dpo .reviewer-records {
  list-style: none;
  margin: 0;
  padding: 0;
}
.admin-dpo .reviewer-records li {
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-line);
}
.admin-dpo .reviewer-records li > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}
.admin-dpo .reviewer-records strong {
  font-size: 14px;
  overflow-wrap: anywhere;
}
.admin-dpo .reviewer-records time {
  margin-left: auto;
  color: var(--ui-muted);
  font-size: 12px;
}
.admin-dpo .reviewer-records p {
  margin-top: 8px;
  max-width: 76ch;
  font-size: 14px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.admin-dpo .result-answers, .admin-dpo .individual-reviews {
  padding: 0 16px;
  border: 1px solid var(--ui-line);
  border-radius: 10px;
  background: var(--ui-soft);
  margin-top: 16px;
}
.admin-dpo .result-answers > summary, .admin-dpo .individual-reviews > summary {
  min-height: 44px;
  padding: 12px 0;
  color: var(--ui-text);
  font-weight: 600;
}
.admin-dpo .individual-reviews > summary > span {
  margin-left: 8px;
  color: var(--ui-muted);
  font-weight: 400;
}
.admin-dpo .individual-reviews .reviewer-records {
  max-height: 480px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 8px;
  scrollbar-color: var(--ui-control) var(--ui-soft);
  scrollbar-width: thin;
}
.admin-dpo .individual-reviews .reviewer-records li:last-child {
  border-bottom: 0;
}
.admin-dpo .result-answer-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  margin: 12px 0 20px;
  padding: 0;
  background: var(--ui-line);
  border: 1px solid var(--ui-line);
  border-radius: 10px;
  overflow: hidden;
}
.admin-dpo .result-answer-grid > section {
  padding: 20px;
  background: var(--ui-paper);
  border-radius: 0;
}
.admin-dpo .result-answer-grid p, .admin-dpo .result-evidence p {
  margin-top: 8px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 16px;
  line-height: 1.85;
}
.admin-dpo .result-evidence {
  padding: 16px 0;
  border-top: 1px solid var(--ui-line);
}
.admin-dpo .result-evidence .evidence-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  margin-top: 16px;
  overflow-wrap: anywhere;
}
.admin-dpo .result-evidence .evidence-links small {
  color: var(--ui-muted);
}
.admin-dpo .result-evidence h4 {
  margin-top: 20px;
}
.admin-dpo .result-evidence details {
  margin-top: 12px;
}
.admin-dpo .result-evidence summary {
  min-height: 44px;
  padding-block: 8px;
}
.admin-dpo .result-evidence ul {
  padding-left: 20px;
  color: var(--ui-warning);
}

@media (max-width: 1000px) {
  .admin-dpo .result-columns, .admin-dpo .result-row {
    grid-template-columns: 94px minmax(0, 1fr) 16px;
    gap: 8px 12px;
  }
  .admin-dpo .result-columns > span:nth-child(3) {
    display: none;
  }
  .admin-dpo .result-row > .result-votes {
    grid-column: 2;
  }
  .admin-dpo .result-row > i {
    grid-column: 3;
    grid-row: 1;
  }
}
@media (max-width: 800px) {
  .admin-dpo .admin-dpo-heading {
    gap: 12px;
  }
  .admin-dpo .participation-table th, .admin-dpo .participation-table td {
    padding: 8px;
  }
  .admin-dpo .participation-progress progress {
    display: none;
  }
}
@media (max-width: 960px), (pointer: coarse) {
  .admin-dpo :is(.admin-dpo-views button, .button, .icon-button, .text-button, .pagination button, input, select, summary) {
    min-height: 44px;
  }
}
@media (min-width: 601px) and (max-width: 960px), (min-width: 601px) and (pointer: coarse) {
  .admin-dpo .results-tools {
    grid-template-columns: minmax(144px, 1fr) 125px 156px 44px;
  }
}
@media (max-width: 600px) {
  .admin-dpo {
    padding: 12px;
  }
  .admin-dpo .admin-dpo-heading {
    gap: 8px;
    margin: -12px -12px 12px;
    padding: 12px;
    flex-wrap: wrap;
  }
  .admin-dpo .direct-review {
    display: none;
  }
  .admin-dpo .admin-dpo-heading h2 {
    font-size: 15px;
    flex-basis: 100%;
  }
  .admin-dpo .admin-dpo-views {
    display: flex;
    flex: 1;
    min-width: 0;
  }
  .admin-dpo .admin-dpo-views button {
    flex: 1;
    min-width: 0;
    min-height: 44px;
    padding: 6px;
    font-size: 12px;
  }
  .admin-dpo .button, .admin-dpo .icon-button, .admin-dpo .text-button, .admin-dpo .pagination button {
    min-height: 44px;
  }
  .admin-dpo .icon-button, .admin-dpo .pagination button {
    min-width: 44px;
  }
  .admin-dpo input, .admin-dpo select {
    font-size: 16px;
    min-height: 44px;
  }
  .admin-dpo .participation-meta {
    gap: 2px 12px;
  }
  .admin-dpo .participation-note {
    margin: 0;
    flex-basis: 100%;
  }
  .admin-dpo .participation-tools {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .admin-dpo .participation-search {
    flex-basis: 100%;
  }
  .admin-dpo .participation-filter {
    flex-wrap: wrap;
  }
  .admin-dpo .participation-filter button {
    min-height: 44px;
  }
  .admin-dpo .participation-search {
    grid-column: 1/-1;
  }
  .admin-dpo .participation-search .icon-button {
    width: 44px;
    flex: none;
  }
  .admin-dpo .participation-refresh {
    justify-self: end;
  }
  .admin-dpo .participation-table, .admin-dpo .participation-table tbody {
    display: block;
  }
  .admin-dpo .participation-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
  .admin-dpo .participation-table .participation-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px 12px;
    border-bottom: 1px solid var(--ui-line);
    padding: 12px 0;
  }
  .admin-dpo .participation-table th.participation-person {
    width: auto;
    grid-column: 1/-1;
    text-align: left;
    padding: 0;
    border: 0;
  }
  .admin-dpo .participation-table td {
    padding: 0;
    border: 0;
    text-align: left;
  }
  .admin-dpo .participation-table tbody tr:hover {
    background: transparent;
  }
  .admin-dpo .participation-table .mobile-label {
    display: block;
    color: var(--ui-muted);
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 3px;
  }
  .admin-dpo .participation-table .participation-progress {
    grid-column: 1/-1;
    grid-row: 3;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .admin-dpo .participation-progress > div {
    flex: 1;
  }
  .admin-dpo .participation-progress .mobile-label {
    margin: 0;
  }
  .admin-dpo .participation-progress progress {
    display: block;
    max-width: none;
  }
  .admin-dpo .participation-progress > div > span {
    text-align: right;
  }
  .admin-dpo .results-meta {
    gap: 2px;
  }
  .admin-dpo .results-summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    gap: 4px 12px;
  }
  .admin-dpo .results-summary > div {
    flex-wrap: wrap;
    gap: 0 6px;
  }
  .admin-dpo .results-policy {
    margin-left: 0;
    width: 100%;
  }
  .admin-dpo .results-policy > summary {
    min-height: 44px;
    padding: 12px 0;
  }
  .admin-dpo .results-controls {
    gap: 8px;
  }
  .admin-dpo .results-tools {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr) 44px;
    gap: 8px;
    flex-basis: 100%;
    width: 100%;
  }
  .admin-dpo .result-search {
    grid-column: 1/-1;
  }
  .admin-dpo .result-filter select {
    padding-inline: 6px;
    font-size: 16px;
  }
  .admin-dpo .results-list-actions {
    width: 100%;
    margin: 0;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
  }
  .admin-dpo .result-exports {
    margin-left: auto;
  }
  .admin-dpo .result-exports[open] {
    width: 100%;
  }
  .admin-dpo .result-export-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }
  .admin-dpo .results-list-actions .button {
    padding: 8px;
    font-size: 12px;
    white-space: normal;
    line-height: 18px;
  }
  .admin-dpo .result-export-options .primary {
    grid-column: 1/-1;
  }
  .admin-dpo .bundle-download > a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
  }
  .admin-dpo .result-columns {
    display: none;
  }
  .admin-dpo .result-row {
    grid-template-columns: minmax(0, 1fr) 16px;
    gap: 8px;
    padding: 12px 0;
  }
  .admin-dpo .result-row > .badge {
    grid-column: 1;
  }
  .admin-dpo .result-question {
    grid-column: 1/-1;
  }
  .admin-dpo .result-question strong {
    font-size: 14px;
  }
  .admin-dpo .result-row > .result-votes {
    grid-column: 1/-1;
  }
  .admin-dpo .result-row > i {
    grid-column: 2;
  }
  .admin-dpo .reviewer-records time {
    width: 100%;
    margin: 0;
  }
  .admin-dpo .result-detail > h2 {
    font-size: 19px;
  }
  .admin-dpo .result-answers, .admin-dpo .individual-reviews {
    padding-inline: 12px;
  }
  .admin-dpo .result-answer-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 1px;
  }
  .admin-dpo .result-answer-grid > section {
    padding: 14px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .admin-dpo :is(.admin-dpo-views button, .button, .icon-button, .result-row) {
    transition: none;
  }
}
.admin-permission-error {
  color: var(--ui-danger);
  padding: 16px 0;
  font-size: 14px;
}

.admin-permission-error a {
  color: var(--ui-accent);
  text-decoration: underline;
}

/* An unevaluated row has no distribution to scan; detailed counts stay in the item view. */
.admin-dpo .result-empty-votes {
  font-size: 12px;
  color: var(--ui-muted);
}

@media (max-width: 1000px) {
  .admin-dpo .result-row > .result-votes.is-empty {
    display: none;
  }
}
/* Disclosure buttons use the same text/chevron spacing as other controls. */
.admin-dpo .results-list-actions :is(.result-create, .result-exports) > summary {
  padding-inline: 14px;
  gap: 10px;
  white-space: nowrap;
}

.admin-dpo .results-list-actions :is(.result-create, .result-exports) > summary > :is(i, svg) {
  flex: none;
}`],
})
export class ComponentAdminDpoComponent implements OnInit, OnDestroy, OnChanges {
    @Input() user:any=null;
    @Input() csrf='';
    @Input() initialView='participants';
    @Output() viewChange=new EventEmitter<string>();
    private initialized=false; private pendingRouteView:string|null=null;
    view='participants'; busy=false; error=''; notice=''; forbidden=false; resultsReady=false;
    private dead=false; private controllers=new Set<AbortController>();
    resultSelected:any=null; bundlePreparing=false; lastBundle:any=null; resultRows:any={items:[],total:0,page:1,pages:1,summary:{},reviewers:[],exportable_count:0};
    participation:any={items:[],total:0,page:1,pages:1,page_size:10,target_total:0,summary:{}};
    participationReady=false; participationBusy=false; participationError='';
    participantQuery=''; participantStatus='all'; appliedParticipantQuery=''; appliedParticipantStatus='all';
    participantStates=[{id:'all',label:'전체'},{id:'unstarted',label:'미참여'},{id:'in_progress',label:'진행 중'},{id:'completed',label:'완료'}];
    resultQuery=''; resultStatus=''; resultScope='all'; appliedResultQuery=''; appliedResultStatus=''; appliedResultScope='all';
    resultStates=[{id:'',label:'전체 결과'},{id:'READY',label:'다수 선호'},{id:'TIE',label:'동률·우세 없음'},{id:'HOLD',label:'판단 보류'},{id:'INCOMPLETE',label:'평가 부족'},{id:'EMPTY',label:'미평가'}];

    reviewScopes=[{id:'all',label:'전체 자료'},{id:'ready',label:'원문 확인 필요 제외'},{id:'source_review',label:'원문 확인 필요'},{id:'supplemented',label:'교정·보충 근거'}];
    constructor(@Inject(Service) public service:Service) {}
    get canManage() {return !this.forbidden&&this.user?.role==='admin'&&this.user?.status==='active';}
    get resultsOpen() {return this.view==='results';}
    get exportableCount() {return this.resultsOpen&&typeof this.resultRows.exportable_count==='number' ? this.resultRows.exportable_count : null;}
    get canExport() {return this.canManage&&this.resultsOpen&&!this.busy&&this.exportableCount!==null&&this.exportableCount>0;}
    async ngOnInit() {
        await this.service.init();if(this.dead||!this.canManage)return;
        this.initialized=true;this.view=this.initialView==='results'?'results':'participants';
        if(this.resultsOpen)await this.searchResults();else await this.loadParticipation();
    }
    async ngOnChanges(changes:SimpleChanges) {
        if(!changes.initialView||!this.initialized||this.dead||!this.canManage)return;
        this.pendingRouteView=this.initialView==='results'?'results':'participants';
        await this.flushRouteView();
    }
    async flushRouteView() {
        if(this.dead||!this.canManage||this.busy||this.pendingRouteView===null)return;
        const view=this.pendingRouteView;this.pendingRouteView=null;
        await this.activateView(view,false);
    }
    ngOnDestroy() {this.dead=true;this.pendingRouteView=null;this.controllers.forEach(c=>c.abort());}
    async render() {if(!this.dead)await this.service.render();}
    async focus(id:string) {
        await this.render();if(this.dead)return;
        const e=document.getElementById(id);e?.scrollIntoView({block:'nearest',behavior:'instant'});e?.focus({preventScroll:true});
    }
    async task(fn:()=>Promise<void>) {
        if(this.busy||this.dead||!this.canManage)return;
        this.busy=true;this.error='';this.notice='';await this.render();
        try {if(!this.dead)await fn();}catch(e:any){if(!this.dead)this.error=e?.message||'요청을 처리하지 못했습니다. 다시 시도해 주세요.';}
        finally {this.busy=false;await this.render();await this.flushRouteView();}
    }
    async switchView(view:string) {
        if(this.busy||this.dead||!this.canManage||!['participants','results'].includes(view))return;
        this.pendingRouteView=null;await this.activateView(view,true);
    }
    async activateView(view:string,emit:boolean) {
        if(this.dead||!this.canManage||view===this.view)return;
        this.view=view;this.error='';this.notice='';this.resultSelected=null;
        if(emit)this.viewChange.emit(view);
        await this.render();
        if(this.view!==view)return;
        if(view==='results'&&!this.resultsReady)await this.searchResults(this.resultRows.page,false);
        if(view==='participants'&&!this.participationReady)await this.loadParticipation(this.participation.page,false);
    }
    label(value:string) {return ({A:'A 선호',B:'B 선호',TIE:'동률',HOLD:'보류'} as any)[value]||'미평가';}
    date(value:string) {return formatWorkspaceDate(value);}
    async call(action:string,values:any={}) {
        if(!this.canManage)throw new Error('관리자만 평가 결과를 확인할 수 있습니다.');
        const controller=new AbortController();this.controllers.add(controller);const timer=setTimeout(()=>controller.abort(),action==='export_bundle'?180000:30000);
        try {
            const body=new URLSearchParams();
            for(const [k,v] of Object.entries({action,csrf:this.csrf,...values})) body.append(k,String(v));
            const response=await fetch('/wiz/api/page.dpo/dispatch',{method:'POST',body,credentials:'same-origin',signal:controller.signal});
            const r=await response.json();
            if(this.dead||!this.canManage)throw new Error('화면을 닫아 요청을 취소했습니다.');
            if(r.code!==200) {
                const code=r.code || response.status;
                if(code===401) {this.forbidden=true;throw new Error('로그인이 만료되었습니다. 다시 로그인해 주세요.');}
                if(code===403) {this.forbidden=true;throw new Error(r.data?.message || '이 작업을 수행할 권한이 없습니다. 계정 권한을 확인해 주세요.');}
                if(code===409) throw new Error('다른 작업에서 이 기록이 변경되었습니다. 입력 내용을 보관한 뒤 최신 기록을 다시 열어 주세요.');
                throw new Error(r.data?.message || '요청을 처리하지 못했습니다. 입력 내용을 확인하고 다시 시도해 주세요.');
            }
            return r.data;
        } catch(e:any) {
            if(e?.name==='AbortError')throw new Error(action==='export_bundle'?'결과 자료 준비가 지연되고 있습니다. 잠시 후 다시 시도해 주세요.':'응답이 지연되고 있습니다. 잠시 후 다시 조회해 주세요.');
            if(e instanceof TypeError || e instanceof SyntaxError)throw new Error('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
            throw new Error(e?.message || '요청을 처리하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
        } finally {clearTimeout(timer);this.controllers.delete(controller);}
    }

    resultLabel(status:string,consensus:string='') {return status==='READY'&&['A','B'].includes(consensus) ? consensus+' 우세' : this.resultStates.find(s=>s.id===status)?.label || (status==='REVIEW'?'확인 필요':'미평가');}
    async loadParticipation(page=1,applyFilters=true) {
        if(this.dead||this.participationBusy||!this.canManage||this.view!=='participants')return;
        const q=applyFilters?this.participantQuery:this.appliedParticipantQuery;
        const status=applyFilters?this.participantStatus:this.appliedParticipantStatus;
        this.participationBusy=true;this.participationError='';await this.render();
        try {
            const rows=await this.call('participation',{q,status,page});
            if(this.dead||!this.canManage||this.view!=='participants')return;
            this.participation=rows;this.participationReady=true;
            this.appliedParticipantQuery=q;this.appliedParticipantStatus=status;
            this.participantQuery=q;this.participantStatus=status;
        } catch(e:any) {
            if(!this.dead&&this.canManage&&this.view==='participants')this.participationError=e?.message || '참여 현황을 불러오지 못했습니다. 다시 시도해 주세요.';
        } finally {this.participationBusy=false;await this.render();}
    }
    async searchResults(page=1,applyFilters=true) {
        if(this.busy||this.dead||!this.resultsOpen||!this.canManage)return;
        const q=applyFilters?this.resultQuery:this.appliedResultQuery;
        const status=applyFilters?this.resultStatus:this.appliedResultStatus;
        const scope=applyFilters?this.resultScope:this.appliedResultScope;
        await this.task(async()=>{
            const rows=await this.call('results',{q,status,page,review_scope:scope});
            if(this.dead||!this.canManage||this.view!=='results')return;this.resultsReady=true;this.lastBundle=null;this.resultRows=rows;this.appliedResultQuery=q;this.appliedResultStatus=status;this.appliedResultScope=scope;this.resultSelected=null;
        });
        this.resultQuery=this.appliedResultQuery;this.resultStatus=this.appliedResultStatus;this.resultScope=this.appliedResultScope;await this.render();
    }
    async openResult(row:any) {
        if(this.busy||this.dead||!this.resultsOpen||!this.canManage)return;
        await this.task(async()=>{this.resultSelected=await this.call('result_detail',{id:row.id});});
        if(!this.error)await this.focus('result-question');
    }
    async closeResult() {
        if(this.busy||this.dead)return;
        this.resultSelected=null;await this.focus('results-heading');
    }
    async exportPairs() {await this.exportResults('dpo');}
    async exportResults(kind:string) {
        if(this.busy||this.dead||!this.resultsOpen||!this.canManage||!['dpo','csv','bundle'].includes(kind))return;
        if(kind==='dpo'&&!this.canExport)return;
        if(kind!=='dpo'&&!this.resultRows.total)return;
        this.bundlePreparing=kind==='bundle';
        try {
            await this.task(async()=>{
                const action=kind==='bundle'?'export_bundle':kind==='csv'?'export_results_csv':'export';
                const d=await this.call(action,{q:this.appliedResultQuery,status:this.appliedResultStatus,review_scope:this.appliedResultScope});
                if(this.dead)return;
                if(kind==='bundle') {
                    if(!/^[a-f0-9]{32}$/.test(d.export_id||'') || d.download_url!=='/wiz/api/page.dpo/download?export_id='+d.export_id)throw new Error('결과 파일의 주소를 확인할 수 없습니다. 다시 시도해 주세요.');
                    this.lastBundle=d;
                    const a=document.createElement('a');a.href=d.download_url;a.download=d.filename;a.click();
                    this.notice='결과 자료가 준비되었습니다. '+d.count+'개 문항 · 학습용 '+d.training_count+'건';
                } else {
                    const type=kind==='csv'?'text/csv;charset=utf-8':'application/x-ndjson;charset=utf-8';
                    const url=URL.createObjectURL(new Blob([d.content],{type}));
                    const a=document.createElement('a');a.href=url;a.download=d.filename;a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
                    this.notice=kind==='csv'?d.count+'개 문항의 집계표를 저장했습니다.':d.count+'개 학습용 선호쌍을 저장했습니다. 소수 의견은 집계·개별 평가 기록에 보존됩니다.';
                }
            });
        } finally {this.bundlePreparing=false;await this.render();}
    }

}

export default ComponentAdminDpoComponent;